// extracted by mini-css-extract-plugin
export var alertIcon = "_up-0";